import { useCallback } from 'react';
import { useAuthFetch } from '@cko/dashboard-shared';
import { QueryFunctionContext } from '@tanstack/react-query';
import { Entitlement } from '@cko/dashboard-shared';

export type UserEntitlementResponseData = {
  type: Entitlement;
  client_id: string;
  entity_id: string;
};

export type CurrentUserResponseData = {
  first_name: string;
  last_name: string;
  email: string;
  user_id: string;
  user_entitlements: UserEntitlementResponseData[];
  current_role_names: string[];
  is_federated: boolean;
  _links: {
    [key: string]: { href: string };
  };
};

export const useGetCurrentUserFetcher = () => {
  const fetch = useAuthFetch();
  return useCallback(
    async ({ queryKey }: QueryFunctionContext) => {
      const [path] = queryKey as [string];

      const response = await fetch(path, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const data: CurrentUserResponseData = await response.json();

      return data;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fetch],
  );
};
